import React, {useState} from 'react';
import PropTypes from 'prop-types';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import dayjs from 'dayjs';
import appConfig from 'config/app.config';
import {facilitatorUiTexts} from 'data/ui-texts';
import Button from 'components/ui/button/button';
import DeleteUserPopup from './delete-user-popup/delete-user-popup';
import './users.scss';

const Users = ({userId, users, allowedUsers, handleGoToPage, deleteUser}) => {
	/* Loading status, error message */
	const [isLoading, setIsLoading] = useState(false);
	const [errMsg, setErrMsg] = useState(null);

	/* Input: email */
	const [email, setEmail] = useState(null);

	/* Delete user popup */
	const [deleteUserData, setDeleteUserData] = useState(null);

	/**
	 * Update email
	 * @param {object} event 
	 */
	const updateEmail = (event) => {
		if (isLoading) return;
		setErrMsg(null);
		setEmail(event.target.value);
	};

	/* Add new allowed user */
	const handleAddAllowedUser = () => {
		if (isLoading) return;
		setErrMsg(null);
		setIsLoading(true);

		if (email && email.length > 0) {
			const lowercaseEmail = email.toLowerCase().trim();
			if (allowedUsers.some((u) => {return u.email === lowercaseEmail;})) {
				setErrMsg('E-mail allerede tilføjet');
				setIsLoading(false);
			} else {
				const db = firebase.firestore();
				db.collection(appConfig.allowedUsersDbName).add(
					{email:lowercaseEmail, added: dayjs(new Date()).format('YYYY-MM-DD hh:mm:ss')}
				).then(() => {
					setEmail(null);
					setIsLoading(false);
				});
			}
		} else {
			setIsLoading(false);
		}
	};

	/* Remove allowed user (not created yet) */
	const handleRemoveAllowedUser = (uid) => {
		if (isLoading) return;

		setIsLoading(true);
		setErrMsg(null);
		const db = firebase.firestore();
		db.collection(appConfig.allowedUsersDbName).doc(uid).delete().then(() => {
			setIsLoading(false);
		}).catch((error) => {
			console.error(error);
			setIsLoading(false);
			setErrMsg('Kunne ikke slette e-mail');
		});
	};


	return (
		<div className="Users">
			<div className="Users-addUser">
				<div className="Users-addUserInput">
					<input
						name="email"
						type="text"
						placeholder={facilitatorUiTexts.email}
						value={email ? email : ''}
						onChange={(event) => {updateEmail(event);}}
					/>
				</div>
				<div className="Users-addUserBtn">
					<Button 
						isLoading={isLoading}
						isDisabled={isLoading}
						classes={['red']}
						text={facilitatorUiTexts.addUser}
						onClick={() => {handleAddAllowedUser();}}
					/>
				</div>
			</div>
			<div className="Users-errMsg">
				{errMsg && <span>{errMsg}</span>}
			</div>
			<div className="Users-users">
				<div className="Users-usersHeader">
					<div className="Users-usersItem email">{facilitatorUiTexts.email}</div>
					<div className="Users-usersItem created">{facilitatorUiTexts.status}</div>
					<div className="Users-usersItem delete">{facilitatorUiTexts.delete}</div>
				</div>
				<div className="Users-usersBody">
					{allowedUsers.map((auser) => {
						const userData = users.find((u) => {return u.email === auser.email;});
						const isCreated = users.some((u) => {return u.email === auser.email;});
						return (
							<div key={auser.id} className="Users-usersRow">
								<div className="Users-usersItem email">{auser.email}</div>
								<div className="Users-usersItem created">
									{(isCreated ? facilitatorUiTexts.created : '-')}
								</div>
								<div className="Users-usersItem delete">
									{!isCreated && 
										<Button 
											classes={['delete']}
											onClick={() => {handleRemoveAllowedUser(auser.id);}}
										/>
									}
									{(isCreated && userData.id !== userId && !userData.isAdmin) && 
										<Button 
											classes={['delete']}
											onClick={() => {setDeleteUserData({...userData, auserId: auser.id});}}
										/>
									}
								</div>
							</div>
						);
					})}
				</div>
			</div>

			

			{deleteUserData && <DeleteUserPopup 
				userData={deleteUserData}
				errMsg={errMsg}
				setDeleteUserData={setDeleteUserData}
				deleteUser={deleteUser}
			/>}
		</div>
	);
};

Users.propTypes = {
	userId: PropTypes.string.isRequired,
	users: PropTypes.array.isRequired,
	allowedUsers: PropTypes.array.isRequired,
	deleteUser: PropTypes.func.isRequired,
	handleGoToPage: PropTypes.func.isRequired,
};

export default Users;
